import { render, staticRenderFns } from "./pagefoot.vue?vue&type=template&id=9a3de174&"
import script from "./pagefoot.vue?vue&type=script&lang=js&"
export * from "./pagefoot.vue?vue&type=script&lang=js&"
import style0 from "./pagefoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports